// extracted by mini-css-extract-plugin
export var contentWrapper = "s-module--contentWrapper--4fd2f";
export var featuredAbout = "s-module--featuredAbout--8be02";
export var featuredBlockContainer = "s-module--featuredBlockContainer--d341c";
export var featuredCSR = "s-module--featuredCSR--7e820";
export var featuredContent = "s-module--featuredContent--4ea07";
export var featuredTriumphs = "s-module--featuredTriumphs--9df69";
export var header = "s-module--header--67316";
export var headerBlock = "s-module--headerBlock--1dd18";
export var headerBlockContent = "s-module--headerBlockContent--07947";
export var headerBlockContentWrapper = "s-module--headerBlockContentWrapper--7cc68";
export var headerBlockImage = "s-module--headerBlockImage--93c07";
export var headerBlockImageWrapper = "s-module--headerBlockImageWrapper--89432";
export var icon = "s-module--icon--9261b";
export var leftContent = "s-module--leftContent--42fb9";
export var redBlock = "s-module--redBlock--baed8";
export var smallTitle = "s-module--smallTitle--19cd6";
export var smallTitleConsulting = "s-module--smallTitleConsulting--8c848";
export var themeDarkPurple = "s-module--themeDarkPurple--ee4d4";
export var themeLightBlue = "s-module--themeLightBlue--93c12";
export var themeLightOrange = "s-module--themeLightOrange--fc871";
export var themeNeonGreen = "s-module--themeNeonGreen--42fd8";
export var themeOrange = "s-module--themeOrange--1f3a5";
export var themePink = "s-module--themePink--8062b";
export var themeYellow = "s-module--themeYellow--a5881";